import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { ConsentsTranslations } from '@app/shared/models/consents-translations';
import { IdentifierType } from '@app/core/_models/member-interface';
import { ConsentsComponent } from '@app/shared/components/consents/consents.component';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppFocusableDirective } from '@app/shared/directives/focusable.directive';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { MsisdnInputComponent } from '@app/shared/components/msisdn-input/msisdn-input.component';

@Component({
  selector: 'app-signup-consents',
  templateUrl: 'signup-consents.component.html',
  imports: [
    ReactiveFormsModule,
    ConsentsComponent,
    NgClass,
    TranslatePipe,
    AppFocusableDirective,
    InputErrorsComponent,
    MsisdnInputComponent,
  ],
})

export class SignupConsentsComponent {
  @Input() public identifierType?: IdentifierType;
  @Input() public formGroup: UntypedFormGroup;
  @Input() public formErrors: Record<string, any> = {};
  @Input() public consentsTranslations: ConsentsTranslations;

  public readonly identifierMsisdnType = IdentifierType.MSISDN;
  public readonly identifierEmailType = IdentifierType.EMAIL;
}
